import { render, staticRenderFns } from "./EditEmailModal.vue?vue&type=template&id=0be1c2b0&scoped=true&"
import script from "./EditEmailModal.vue?vue&type=script&lang=js&"
export * from "./EditEmailModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0be1c2b0",
  null
  
)

export default component.exports